import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultObjectiveResource,
    ObjectiveMutationResourceSchema,
    ObjectivePropertyValidation,
    useObjectiveActions,
} from '../../../../../resource/resources/artifacts/objective/objectiveResource';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { SingleParentedOverviewComponent } from '../../../../reusable-components/resource-overviews/SingleParentedOverviewComponent';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ObjectiveContent } from './ObjectiveContent';

const ObjectiveOverviewContent = ({ id, displayedInOverview }: { id: string; displayedInOverview: boolean }) => {
    const readOnly = useSelector(selectReadOnly);

    const objectiveActions = useObjectiveActions();
    const objectiveQuery = objectiveActions.useGetResource(id);
    const updateObjective = objectiveActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ObjectiveMutationResourceSchema,
        defaultValues: defaultObjectiveResource,
        submitHandler: async (data) => {
            await updateObjective.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: objectiveQuery.data,
    });

    return (
        <QueryBaseComponent name="Objective" query={objectiveQuery}>
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <ObjectiveContent
                    displayedInOverview={displayedInOverview}
                    form={form}
                    formNames={formNames}
                    readOnly={readOnly}
                    id={id}
                />
            </Form_DisplayComponentBaseView>
        </QueryBaseComponent>
    );
};

export const ObjectiveOverviewComponent = ({ parentId }: { parentId: string }) => {
    const validationScope = useSelector(selectNoScopeValidationScope);

    const objectiveActions = useObjectiveActions();

    const parametersQuery = objectiveActions.useGetAllResources(parentId);

    const resourceType = ResourceType.OBJECTIVE;

    return (
        <QueryBaseComponent name="Objectives" query={parametersQuery}>
            <SingleParentedOverviewComponent
                label={'Objectives'}
                resourceQuery={parametersQuery}
                content={(id, displayedInOverview) => (
                    <ObjectiveOverviewContent id={id} displayedInOverview={displayedInOverview} />
                )}
                propertyValidationInformation={{
                    namePropertyIdentifier: ObjectivePropertyValidation.NAME,
                    resourceType,
                }}
                validationScope={validationScope}
                parentId={parentId}
            />
        </QueryBaseComponent>
    );
};
